<div class="tags-details">
  <h2 *ngIf="tags.value.id !== 0 || editMode">
    <span id="icon" class="material-icons-outlined">label</span>
    <span class="title-details">{{ tagTitle | translate }}</span>
  </h2>

  <div *ngIf="tags.value.id === 0 && !editMode" class="empty-details">
    <span class="material-icons-outlined">label</span>
  </div>

  <div *ngIf="tags.value.id !== 0 || editMode" class="tags-info-container">
    <div *ngIf="tags.value.id !== 0 && !editMode" class="tags-info">
      <table>
        <tr>
          <td>
            <strong>{{ "tagDetails.nameLabel" | translate }}:</strong>
          </td>
          <td>{{ tags.value.value }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "tagDetails.colorLabel" | translate }}:</strong>
          </td>
          <td>
            <span
              [style.background-color]="tags.value.color"
              class="color-preview"
            ></span>
            {{ tags.value.color }}
          </td>
        </tr>
      </table>

      <div class="btn">
        <button class="btn-edit" (click)="toggleEditMode()">
          <span class="material-icons-outlined">edit</span>
          {{ "tagDetails.editButton" | translate }}
        </button>
        <button class="btn-delete" (click)="deleteTag()">
          <span class="material-icons-outlined">delete</span>
          {{ "tagDetails.deleteButton" | translate }}
        </button>
      </div>
    </div>

    <form [formGroup]="tagsForm" *ngIf="editMode">
      <div class="form-group">
        <label for="name">{{ "tagDetails.nameLabel" | translate }}:</label>
        <input type="text" id="name" formControlName="name" />
        <div class="color">
          <label for="color">{{ "tagDetails.colorLabel" | translate }}:</label>

          <input type="color" id="color" formControlName="color" />
        </div>
        <messages
          class="msg"
          [form]="tagsForm"
          [messagesObserver]="messages"
          fieldname="name"
        ></messages>
      </div>
      <div class="action-buttons">
        <action-button
          (actionEvent)="saveTag($event)"
          label="{{ 'tagDetails.saveButton' | translate }}"
        >
          <span class="material-icons-outlined">save</span>
          {{ "tagDetails.saveButton" | translate }}
        </action-button>

        <button type="button" class="btn-cancel" (click)="toggleEditMode()">
          <span class="material-icons-outlined">cancel</span>
          {{ "tagDetails.cancelButton" | translate }}
        </button>
      </div>
      <messages
        class="message"
        [form]="tagsForm"
        [messagesObserver]="messages"
        fieldname="tags"
      ></messages>
    </form>
  </div>
</div>
